// Translation system for HelpDesk application

const translations = {
  tr: {
    // Navigation
    dashboard: "Panel",
    board: "Pano",
    tickets: "Talepler",
    reports: "Raporlar",
    projects: "Projeler",
    team: "Takım",
    settings: "Ayarlar",
    profile: "Profil",
    logout: "Çıkış Yap",

    // Settings
    settingsTitle: "Ayarlar",
    settingsSubtitle: "Hesabınızı ve uygulama tercihlerinizi yönetin",

    // Appearance
    appearance: "Görünüm",
    appearanceDesc: "Arayüz teması ve görsel tercihler",
    darkMode: "Karanlık Mod",
    darkModeEnabled: "Karanlık tema etkin",
    lightModeEnabled: "Açık tema etkin",

    // Language
    language: "Dil",
    languageDesc: "Uygulama dilini seçin",
    turkish: "Türkçe",
    english: "English",

    // Font Size
    fontSize: "Font Boyutu",
    fontSizeDesc: "Metin boyutunu ayarlayın",
    small: "Küçük",
    medium: "Orta",
    large: "Büyük",

    // Common
    save: "Kaydet",
    cancel: "İptal",
    loading: "Yükleniyor...",
    error: "Hata",
    success: "Başarılı",
    edit: "Düzenle",
    delete: "Sil",
    deleteConfirm: "Bu ticket'ı silmek istediğinizden emin misiniz?",
    deleteError: "Ticket silinirken hata oluştu!",

    // Dashboard
    welcomeBack: "Tekrar Hoş Geldin",
    totalTickets: "Toplam Talep",
    openTickets: "Açık Talep",
    closedTickets: "Kapalı Talep",
    pendingTickets: "Bekleyen Talep",
    myTasks: "Görevlerim",
    recentActivity: "Son Aktiviteler",

    // Staff Dashboard specific
    staffDashboard: "Personel Dashboard",
    dailyTasksDesc: "Günlük görevleriniz ve atanan biletleriniz",
    projectTasksDesc: "projesindeki görevleriniz ve biletleriniz",
    myOpenTickets: "Bana Atanan Açık Biletler",
    todayCompleted: "Bugün Tamamlanan",
    pendingTasks: "Bekleyen Görevler",
    urgentTickets: "Acil Biletler",
    dashboardLoading: "Dashboard yükleniyor...",
    noTasksFound: "Henüz görev bulunmuyor",
    myAssignedTasks: "Bana Atanan Görevler",
    recentCompletedTasks: "Son Tamamlanan Görevler",

    // Admin Dashboard
    adminDashboard: "Admin Dashboard",
    systemManagement: "Sistem yönetimi ve genel kontrol paneli",
    totalUsers: "Toplam Kullanıcı",
    activeHotels: "Aktif Otel Sayısı",
    systemStatus: "Sistem Durumu",
    securityAlerts: "Güvenlik Uyarıları",
    systemOverview: "Sistem Genel Durumu",
    systemTasks: "Sistem Görevleri",
    recentSystemActivity: "Son Sistem Aktiviteleri",
    pendingApprovals: "Bekleyen Onaylar",
    systemLoad: "Sistem Yükü",
    avgResponseTime: "Ortalama Yanıt Süresi",
    activeConfigurations: "Aktif Konfigürasyonlar",

    // Chart Labels
    completed: "Bitti",
    inProgress: "Yapılıyor",
    pending: "Beklemede",
    criticalPriority: "Kritik Öncelik",

    // Tickets
    createTicket: "Talep Oluştur",
    ticketTitle: "Talep Başlığı",
    description: "Açıklama",
    priority: "Öncelik",
    status: "Durum",
    assignee: "Atanan",
    category: "Kategori",

    // Priorities
    low: "Düşük",
    medium: "Orta",
    high: "Yüksek",
    urgent: "Acil",

    // Statuses
    // Statuses
    open: "Açık",
    inProgress: "Yapılıyor",
    resolved: "Çözüldü",
    closed: "Kapalı",
    pending: "Beklemede",
    completed: "Bitti",

    // DataTable
    searchPlaceholder: "Ara...",
    noRecordsFound: "Kayıt bulunamadı.",
    recordsListed: "KAYIT LİSTELENDİ",

    // Ticket Page
    myRequests: "Taleplerim",
    myRequestsSubtitle: "Oluşturduğunuz destek taleplerini yönetin ve takip edin",
    searchTickets: "Talepleri ara...",
    allStatuses: "Tüm Durumlar",
    allPriorities: "Tüm Öncelikler",
    filters: "Filtreler",
    createdDate: "Oluşturulan Tarih",
    completedDate: "Bitiş Tarihi",
    ticketsShown: "ticket gösteriliyor",
    lastUpdate: "Son güncelleme",
    errorOccurred: "Hata Oluştu",
    tryAgain: "Tekrar Dene",

    // Ticket Details
    details: "Detaylar",
    history: "Geçmiş",
    comments: "Yorumlar",
    reporter: "Raporlayan",
    project: "Proje",
    department: "Departman",
    unassigned: "Atanmamış",
    saveChanges: "Değişiklikleri Kaydet",
    editTitle: "Başlığı Düzenle",
    editDescription: "Açıklamayı Düzenle",
    addComment: "Yorum Ekle",
    deleteConfirmComment: "Bu yorumu silmek istediğinizden emin misiniz?",
    noAttachments: "Ekli dosya yok.",
    images: "Görseller",
    attachments: "Ekler",
    download: "İndir",
    logWork: "Çalışma Kaydet",
    updating: "Güncelleniyor...",
    update: "Güncelle",
    adding: "Ekleniyor...",
    addCommentPlaceholder: "Yorum ekleyin...",
    firstCommentPlaceholder: "İlk yorumu siz yapın...",
    noComments: "Henüz yorum yok",
    noReporterInfo: "Reporter bilgisi bulunmuyor",
    removeAssignment: "Görev atamayı kaldır",
    unknownUser: "Bilinmeyen Kullanıcı",
    anonymous: "Anonim",
    saving: "Kaydediliyor...",
    noDescription: "Açıklama belirtilmemiş.",
    timeTracking: "Zaman Takibi",
    estimated: "Tahmini",
    logged: "Kaydedilen",
    remaining: "Kalan",
    labels: "Etiketler",
    me: "Ben",
    addingNewComment: "Yeni yorum ekliyorsunuz",
    loadingComments: "Yorumlar yükleniyor...",
    user: "Kullanıcı",
    startConversation: "Bir şeyler yazarak iletişimi başlatın.",
    updatedStatusFrom: "durumu şundan değiştirdi:",
    to: "şuna:",
    createdThisTicket: "bu talebi oluşturdu",
    hoursAgo: "saat önce",
    daysAgo: "gün önce",
    historyLoading: "Geçmiş yükleniyor...",
    historyEmpty: "Henüz kayıt yok.",
    historyLoadError: "Geçmiş yüklenemedi.",
    historyCommentAdded: "yorum ekledi",
    historyAttachmentAdded: "dosya ekledi:",
    historySubTicketAdded: "alt ticket ekledi:",
    historyTicketDeactivated: "bu talebi devre dışı bıraktı",
    historyDescriptionUpdated: "Açıklamayı güncelledi",
    historyOpenSubTicket: "Alt ticket'a git",
    historyFieldTitle: "Başlık",
    historyFieldPriority: "Öncelik",
    historyFieldAssignee: "Atanan",
    historyFieldTopic: "Konu",
    historyFieldTicketType: "Tür",
    historyFieldParentTicket: "Üst ticket",
    historyFieldDueDate: "Bitiş tarihi",

    subTickets: "Alt ticket'lar",
    subTicketNew: "Yeni alt ticket",
    subTicketEdit: "Alt ticket düzenle",
    parentTicketLink: "Üst ticket'a dön",
    subTicketTitle: "Başlık",
    subTicketDeleteConfirm: "Bu alt ticket silinsin mi?",
    subTicketColTitle: "Başlık",
    subTicketColStatus: "Durum",
    subTicketColPriority: "Öncelik",
    subTicketColAssignee: "Atanan",
    subTicketColDue: "Bitiş",
    subTicketFormIncomplete: "Öncelik ve durum seçilmelidir.",
    subTicketSearchPlaceholder: "Alt ticket'larda ara..."
  },

  en: {
    // Navigation
    dashboard: "Dashboard",
    board: "Board",
    tickets: "Tickets",
    reports: "Reports",
    projects: "Projects",
    team: "Team",
    settings: "Settings",
    profile: "Profile",
    logout: "Logout",

    // Settings
    settingsTitle: "Settings",
    settingsSubtitle: "Manage your account and application preferences",

    // Appearance
    appearance: "Appearance",
    appearanceDesc: "Interface theme and visual preferences",
    darkMode: "Dark Mode",
    darkModeEnabled: "Dark theme enabled",
    lightModeEnabled: "Light theme enabled",

    // Language
    language: "Language",
    languageDesc: "Select application language",
    turkish: "Türkçe",
    english: "English",

    // Font Size
    fontSize: "Font Size",
    fontSizeDesc: "Adjust text size",
    small: "Small",
    medium: "Medium",
    large: "Large",

    // Common
    save: "Save",
    cancel: "Cancel",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    edit: "Edit",
    delete: "Delete",
    deleteConfirm: "Are you sure you want to delete this ticket?",
    deleteError: "Error occurred while deleting ticket!",

    // Dashboard
    welcomeBack: "Welcome Back",
    totalTickets: "Total Tickets",
    openTickets: "Open Tickets",
    closedTickets: "Closed Tickets",
    pendingTickets: "Pending Tickets",
    myTasks: "My Tasks",
    recentActivity: "Recent Activity",

    // Staff Dashboard specific
    staffDashboard: "Staff Dashboard",
    dailyTasksDesc: "Your daily tasks and assigned tickets",
    projectTasksDesc: "your tasks and tickets in the project",
    myOpenTickets: "My Assigned Open Tickets",
    todayCompleted: "Completed Today",
    pendingTasks: "Pending Tasks",
    urgentTickets: "Urgent Tickets",
    dashboardLoading: "Loading dashboard...",
    noTasksFound: "No tasks found yet",
    myAssignedTasks: "My Assigned Tasks",
    recentCompletedTasks: "Recently Completed Tasks",

    // Admin Dashboard
    adminDashboard: "Admin Dashboard",
    systemManagement: "System management and general control panel",
    totalUsers: "Total Users",
    activeHotels: "Active Hotels",
    systemStatus: "System Status",
    securityAlerts: "Security Alerts",
    systemOverview: "System Overview",
    systemTasks: "System Tasks",
    recentSystemActivity: "Recent System Activity",
    pendingApprovals: "Pending Approvals",
    systemLoad: "System Load",
    avgResponseTime: "Avg Response Time",
    activeConfigurations: "Active Configurations",

    // Chart Labels
    completed: "Completed",
    inProgress: "In Progress",
    pending: "Pending",
    criticalPriority: "Critical Priority",

    // Tickets
    createTicket: "Create Ticket",
    ticketTitle: "Ticket Title",
    description: "Description",
    priority: "Priority",
    status: "Status",
    assignee: "Assignee",
    category: "Category",

    // Priorities
    low: "Low",
    medium: "Medium",
    high: "High",
    urgent: "Urgent",

    // Statuses
    // Statuses
    open: "Open",
    inProgress: "In Progress",
    resolved: "Resolved",
    closed: "Closed",
    pending: "To Do",
    completed: "Done",

    // DataTable
    searchPlaceholder: "Search...",
    noRecordsFound: "No records found.",
    recordsListed: "RECORDS LISTED",

    // Ticket Page
    myRequests: "My Requests",
    myRequestsSubtitle: "Manage and track the support requests you created",
    searchTickets: "Search requests...",
    allStatuses: "All Statuses",
    allPriorities: "All Priorities",
    filters: "Filters",
    createdDate: "Created Date",
    completedDate: "Completion Date",
    ticketsShown: "tickets showing",
    lastUpdate: "Last update",
    errorOccurred: "Error Occurred",
    tryAgain: "Try Again",

    // Ticket Details
    details: "Details",
    history: "History",
    comments: "Comments",
    reporter: "Reporter",
    project: "Project",
    department: "Department",
    unassigned: "Unassigned",
    saveChanges: "Save Changes",
    editTitle: "Edit Title",
    editDescription: "Edit Description",
    addComment: "Add Comment",
    deleteConfirmComment: "Are you sure you want to delete this comment?",
    noAttachments: "No attachments.",
    images: "Images",
    attachments: "Attachments",
    download: "Download",
    logWork: "Log Work",
    updating: "Updating...",
    update: "Update",
    adding: "Adding...",
    addCommentPlaceholder: "Add a comment...",
    firstCommentPlaceholder: "Be the first to comment...",
    noComments: "No comments yet",
    noReporterInfo: "No reporter info available",
    removeAssignment: "Remove assignment",
    unknownUser: "Unknown User",
    anonymous: "Anonymous",
    saving: "Saving...",
    noDescription: "No description provided.",
    timeTracking: "Time Tracking",
    estimated: "Estimated",
    logged: "Logged",
    remaining: "Remaining",
    labels: "Labels",
    me: "Me",
    addingNewComment: "You are adding a new comment",
    loadingComments: "Loading comments...",
    user: "User",
    startConversation: "Start a conversation by writing something.",
    updatedStatusFrom: "updated status from",
    to: "to",
    createdThisTicket: "created this ticket",
    hoursAgo: "hours ago",
    daysAgo: "days ago",
    historyLoading: "Loading history...",
    historyEmpty: "No activity yet.",
    historyLoadError: "Could not load history.",
    historyCommentAdded: "added a comment",
    historyAttachmentAdded: "attached file:",
    historySubTicketAdded: "added sub-ticket:",
    historyTicketDeactivated: "deactivated this ticket",
    historyDescriptionUpdated: "updated the description",
    historyOpenSubTicket: "Open sub-ticket",
    historyFieldTitle: "Title",
    historyFieldPriority: "Priority",
    historyFieldAssignee: "Assignee",
    historyFieldTopic: "Topic",
    historyFieldTicketType: "Type",
    historyFieldParentTicket: "Parent ticket",
    historyFieldDueDate: "Due date",

    subTickets: "Sub-tickets",
    subTicketNew: "New sub-ticket",
    subTicketEdit: "Edit sub-ticket",
    parentTicketLink: "Back to parent ticket",
    subTicketTitle: "Title",
    subTicketDeleteConfirm: "Delete this sub-ticket?",
    subTicketColTitle: "Title",
    subTicketColStatus: "Status",
    subTicketColPriority: "Priority",
    subTicketColAssignee: "Assignee",
    subTicketColDue: "Due",
    subTicketFormIncomplete: "Priority and status are required.",
    subTicketSearchPlaceholder: "Search sub-tickets..."
  }
};

export const useTranslation = (language = 'tr') => {
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];

    for (const k of keys) {
      value = value?.[k];
    }

    return value || key;
  };

  return { t };
};

export default translations;